import * as React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { usuarioSelector } from '../../selectors/sessionSelector'
import {tiposContenidoSelector} from '../../selectors/contenidoSelector'
import * as contenidoActions from '../../reducers/ContenidoReducer/actions'
import Contenido from '../../components/Contenido'

class ContenidoContainer extends React.Component {

    constructor(props) {
        super(props)
               
        const oTipoContenidoSelected = JSON.parse(localStorage.getItem('idTipoContenidoSelected'));
        let tipoContenidoSelected = oTipoContenidoSelected?oTipoContenidoSelected.idTipoContenidoSelected:(this.props.dataContenido.tiposContenido && this.props.dataContenido.tipoContenidoSelected ? this.props.dataContenido.tipoContenidoSelected : undefined);

        this.state = {
            tipoContenidoSelected: tipoContenidoSelected,//this.props.dataContenido.tiposContenido && this.props.dataContenido.tipoContenidoSelected ? this.props.dataContenido.tipoContenidoSelected : tipoContenidoSelected,
            tipoContenidoSelectedImg: tipoContenidoSelected ? tipoContenidoSelected : 1,
            usuarioCargado: false,
            tiposContenidoCargados: false,
            openModalVer: false,
            itemSelectedVer: undefined,
            itemSelectedEditar: undefined,
            itemABorrar: undefined,
            openModalBorrar: false,
            itemTipoContenidoSelected: tipoContenidoSelected
        }
        this.props.sagaGetTiposContenido()        
    }  

    componentDidUpdate = () => {
        if(this.state.usuarioCargado === false && this.props.usuario !== undefined){
            this.setState({usuarioCargado: true}, () => {
                if(this.props.usuario.idRol === 4){
                    window.location.hash = '/Pedidos'
                }
            })
        }

        if(this.state.tiposContenidoCargados === false && this.props.dataContenido.tiposContenido !== undefined){
            const oTipoContenidoSelected = JSON.parse(localStorage.getItem('idTipoContenidoSelected'));

            let tipoContenidoSelected = oTipoContenidoSelected?oTipoContenidoSelected.idTipoContenidoSelected:this.props.dataContenido.tiposContenido[0].idTipoContenido
            let itemTipoContenidoSelected = this.props.dataContenido.tiposContenido[0]
           
            this.setState({tiposContenidoCargados: true, tipoContenidoSelected: tipoContenidoSelected, itemTipoContenidoSelected: itemTipoContenidoSelected}, () => {
                //buscar contenido                                
                this.props.setTipoContenidoSelected(tipoContenidoSelected)
                this.props.sagaGetContenido(tipoContenidoSelected)
            })
        }
    }

    componentDidMount=()=>{
        window.onbeforeunload = function (e) {
            localStorage.removeItem('idTipoContenidoSelected');
            return undefined;
        };
    }

    handleOnSwap = (ids, idTipoContenido) => {
        let payload = {
            ids: ids,
            idTipoContenido: idTipoContenido
        }
       
        this.props.sagaSwapContenido(payload)
    }

    handleOnChangeTipoContenido = (e) => {
        let value = e.target.value
        this.setState({tipoContenidoSelected: value}, () => {
            //this.props.sagaGetContenido(value)
        })
    }

    handleOnClickBuscar = () => {
        let value = this.state.tipoContenidoSelected
        if(value === undefined){
            return
        }

        let itemTipoContenidoSelected = undefined

        this.props.dataContenido.tiposContenido.forEach(tc => {
            if(tc.idTipoContenido === value){
                itemTipoContenidoSelected = tc
            }
        });


        this.setState({tipoContenidoSelectedImg: value}, () => {
        });

        this.setState({itemTipoContenidoSelected: itemTipoContenidoSelected}, () => {
            this.props.setTipoContenidoSelected(value)
            this.props.sagaGetContenido(value)
        });
    }

    handleOnClickVer = (item) => {
        this.setState({openModalVer: item === undefined ? false : true, itemSelectedVer: item})
    }

   
    handleOnClickBorrar = (item, confirma) => {

        if(confirma === false){
            if(item === undefined){
                return
            }

            this.setState({itemABorrar: item, openModalBorrar: true})
        }
        else{
            let contenido = this.state.itemABorrar
            if(contenido === undefined){
                return
            }

            this.setState({itemABorrar: undefined, openModalBorrar: false}, () => {
                this.props.sagaBorrarContenido(contenido.idContenido)
            })
        }
    }

    handleOnClickCerrarModal = () => {
        this.setState({openModalBorrar: false,openModalVer: false})
    }

    render() {
        return (
            <Contenido
                tipoContenidoSelectedImg={this.state.tipoContenidoSelectedImg}
                tipoContenidoSelected={this.state.tipoContenidoSelected}
                tiposContenido={this.props.dataContenido.tiposContenido}
                itemTipoContenidoSelected={this.state.itemTipoContenidoSelected}
                contenidos={this.props.dataContenido.contenidos}
                openModalVer={this.state.openModalVer}
                itemSelectedVer={this.state.itemSelectedVer}
                itemSelectedEditar={this.state.itemSelectedEditar}
                openModalBorrar={this.state.openModalBorrar}
                handleOnClickVer={this.handleOnClickVer}
                handleOnClickEditar={this.handleOnClickEditar}
                handleOnChangeTipoContenido={this.handleOnChangeTipoContenido}
                handleOnClickBuscar={this.handleOnClickBuscar}
                handleOnClickBorrar={this.handleOnClickBorrar}
                handleOnClickCerrarModal={this.handleOnClickCerrarModal}
                handleOnSwap={this.handleOnSwap}
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        ...contenidoActions
    }, dispatch)
}

function mapStateToProps(state) {
    return {
        usuario: usuarioSelector(state),
        dataContenido: tiposContenidoSelector(state)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContenidoContainer)